// extracted by mini-css-extract-plugin
export var audioPlayer = "_q8-0";